import avatar0 from "Assets/images/avatar/avatar0.svg";
import avatar1 from "Assets/images/avatar/avatar1.svg";
import avatar2 from "Assets/images/avatar/avatar2.svg";
import avatar3 from "Assets/images/avatar/avatar3.svg";
import avatar4 from "Assets/images/avatar/avatar4.svg";
import avatar5 from "Assets/images/avatar/avatar5.svg";
import avatar6 from "Assets/images/avatar/avatar6.svg";
import avatar7 from "Assets/images/avatar/avatar7.svg";
import avatar8 from "Assets/images/avatar/avatar8.svg";
import avatar9 from "Assets/images/avatar/avatar9.svg";
import selectIcon from "Assets/images/avatar/avatar-select-icon.svg";

export default {
    avatar0,
    avatar1,
    avatar2,
    avatar3,
    avatar4,
    avatar5,
    avatar6,
    avatar7,
    avatar8,
    avatar9,
    selectIcon,
}